<template>
    <LedgerSummary/>
</template>

<script>
    import LedgerSummary from '../components/LedgerSummary';

    export default {
        components: {
            LedgerSummary
        }
    }
</script>
